// 播放模式
export const playMode = {
    // 列表播放
    sequence: 0,
    // 循环
    loop: 1,
    // 随机
    random: 2
}